export const CATEGORIES =  {
    APPLICANT: 'Applicant',
    
    // Assessment Reviewer Categories (6 specialized roles)
    BIOEQUIVALENCE_VALIDATION: 'Assessment Bioequivalence Validation',
    QUALITY_VALIDATION: 'Assessment Quality Validation',
    PHARMACOVIGILANCE: 'Assessment Pharmacovigilance',
    CLINICAL_VALIDATION: 'Assessment Clinical Validation',
    CONTROL_LAB_VALIDATION: 'Assessment Control lab Validation',
    INSPECTION_DEPARTMENT: 'Assessment Inspection Department',
    
    // Groupings for logic checks
    ECTD_ASSESSMENT_CATEGORIES: [
      'Assessment Bioequivalence Validation',
      'Assessment Quality Validation',
      'Assessment Pharmacovigilance',
      'Assessment Clinical Validation'
    ],
    
    COMMITTEE_CATEGORIES: [
      'Assessment Bioequivalence Validation',
      'Assessment Quality Validation',
      'Assessment Pharmacovigilance',
      'Assessment Clinical Validation',
      'Assessment Control lab Validation',
      'Assessment Inspection Department'
    ],
    
    COMMITTEE_ECTD_KEYWORD:"ectd",
    COMMITTEE_LAB_KEYWORD:"lab",
    COMMITTEE_INSPECTION_KEYWORD:"inspection",
  };